
import React from 'react';
import Layout from '@/components/Layout/Layout';
import ProgrammingCalculator from '@/components/Calculator/ProgrammingCalculator';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ProgrammingCalculatorPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/calculators" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Calculators
          </Link>
          <h1 className="text-3xl font-bold mb-2">Programming Calculator</h1>
          <p className="text-gray-600 mb-6">
            Convert between number systems and perform bitwise operations for programming tasks.
          </p>
        </div>
        
        <div className="mb-8">
          <ProgrammingCalculator />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Programming Calculator</h2>
          <p>
            The programming calculator is designed for software developers, computer science students, 
            and IT professionals who need to work with different number systems and bitwise operations.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Features</h3>
          <ul className="list-disc ml-6">
            <li>Convert between decimal, binary, octal, and hexadecimal</li>
            <li>Perform bitwise operations (AND, OR, XOR, NOT, shift)</li>
            <li>Calculate 1's and 2's complement</li>
            <li>Work with different word sizes (8-bit, 16-bit, 32-bit, 64-bit)</li>
            <li>Signed and unsigned integer support</li>
          </ul>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Common Use Cases</h3>
          <ul className="list-disc ml-6">
            <li>Debugging binary data in software development</li>
            <li>Understanding memory representation in computers</li>
            <li>Working with hardware registers and flags</li>
            <li>Converting between different numerical representations</li>
          </ul>
        </div>
      </div>
    </Layout>
  );
};

export default ProgrammingCalculatorPage;
